import React, {useEffect, useState} from 'react';
import {setActionPayload, setActionType} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {useDispatch} from "react-redux";
import {useOutletContext} from "react-router-dom";
import AutoConversionToggle from "../AutoConversionToggle";

const MerchantAutoConversion = ({MerchantAccountID, isChecked}) => {
    const dispatch = useDispatch();
    const [onOpenQrAfterGenerate] = useOutletContext();

    const handle_toggleChange = () => {
        if(sessionStorage.getItem("EntityRole")==="SUPERADMIN"){
            const payload = {
                MerchantAccountID
            }

            dispatch(setActionType(ACTION_TYPES.MANAGE_AUTO_CONVERSION));
            dispatch(setActionPayload(payload));

            onOpenQrAfterGenerate();
        }

    }

    return (
        <AutoConversionToggle isChecked={isChecked} handle_toggleChange={handle_toggleChange} convertText="Convert LBP to USD as payments settle"/>
    );
}

export default MerchantAutoConversion;